/* eslint-disable */
import { ApolloClient, ApolloLink, InMemoryCache, HttpLink, defaultDataIdFromObject } from '@apollo/client';
import gql from 'graphql-tag';
import { onError } from "@apollo/client/link/error";
import { GerVersionFromServer } from 'Core/security';
import { endpoints } from 'Core/defaultValues';

import packageJson from '../../../package.json'

export const clientMutation = async (query, variables, endpoint, headers) => {
	let token = localStorage.getItem('IdToken');
	let refreshTokenValue = localStorage.getItem('RefreshToken');

	let attempts = 0;
	let refreshToken = false;
	let errorData = [];
	let returnCall = false;
	let returnData = null;
	let returnError = null;

	while (!returnCall) {
		returnError = null;
		if (variables.accessToken) {
			variables.accessToken = localStorage.getItem('AccessToken')
		}
		const authLink = new ApolloLink((operation, forward) => {
			operation.setContext({
				headers: headers || {
					authorization: token,
					"app-id": "CLOUD-PM",
					"app-version": packageJson.version,
					"package-name": packageJson.name,
				},
			});

			// Call the next link in the middleware chain.
			return forward(operation);
		});

		const client = new ApolloClient({
			link: authLink.concat(
				ApolloLink.from([
					onError(({ response, graphQLErrors, networkError, operation, forward }) => {
						errorData = response;
						graphQLErrors &&
							graphQLErrors.map((error) => {
								if (error.errorType === 'UnauthorizedException' || error.message === 'NotAuthorizedException: Access Token has expired') refreshToken = true;
							});
					}),
					new HttpLink({
						uri: endpoint,
					}),
				]),
			),
			cache: new InMemoryCache({
				addTypename: false
			}),
			defaultOptions: {
				query: {
					errorPolicy: 'all',
				},
			},
		});

		await client
			.mutate({
				mutation: gql(query),
				variables: variables,
				fetchPolicy: 'no-cache',
				context: {
					fetchOptions: {
						onUploadProgress: (progress) => { },
					},
				},
			})
			.then((res) => {
				returnCall = true;
				returnData = res.data;
			})
			.catch((error) => {
				if (refreshToken) {
					attempts = attempts + 1;
					returnError = error;

					if (attempts === 3) returnCall = true;
				} else {
					returnCall = true;
					returnError = error;
				}
			});

		if (!returnCall) {
			await clientGraphQLAuthMutation(`
				mutation refreshToken($refreshToken: String!) {
					result: refreshToken(refreshToken: $refreshToken) {
						AccessToken
						ExpiresIn
						IdToken
						RefreshToken
					}
				}`,
				{
					refreshToken: refreshTokenValue
				}
			).then(data => {
				if (data && data.result) {
					const { AccessToken, IdToken } = data.result
					localStorage.setItem('IdToken', IdToken);
					localStorage.setItem('AccessToken', AccessToken);
					token = IdToken;
					const eventSuccess = new CustomEvent("refreshToken");
					document.dispatchEvent(eventSuccess);
				}
			}).catch(error => {
				if (error.message === "GraphQL error: Refresh Token has expired" || error.message === "NotAuthorizedException: Invalid Refresh Token") {
					localStorage.clear();
					window.location.replace("/login");
				}
			})
		}
	}

	if (returnCall && returnError && refreshToken) {
		localStorage.clear();
		window.location.replace("/login");
		return
	}

	return new Promise((resolve, reject) => {
		if (!returnError) return resolve(returnData);
		else {
			return reject({
				error: returnError.message,
				innerError: returnError,
				errorData: errorData,
			});
		}
	});
};

export const clientQuery = async (query, variables, endpoint, headers, signal) => {
	let token = localStorage.getItem('IdToken');
	let refreshTokenValue = localStorage.getItem('RefreshToken');

	let attempts = 0;
	let refreshToken = false;
	let errorData = [];
	let returnCall = false;
	let returnData = null;
	let returnError = null;

	GerVersionFromServer()

	while (!returnCall) {
		returnError = null;

		const authLink = new ApolloLink((operation, forward) => {
			operation.setContext({
				headers: headers || {
					authorization: token,
					"app-id": "CLOUD-PM",
					"app-version": packageJson.version,
					"package-name": packageJson.name,
				},
			});

			// Call the next link in the middleware chain.
			return forward(operation);
		});

		const client = new ApolloClient({
			link: authLink.concat(
				ApolloLink.from([
					onError(({ response, graphQLErrors, networkError, operation, forward }) => {
						errorData = response;
						graphQLErrors &&
							graphQLErrors.map((error) => {
								if (error.errorType === 'UnauthorizedException' || error.message === 'NotAuthorizedException: Access Token has expired') refreshToken = true;
							});
					}),
				new HttpLink({
					uri: endpoint,
					fetchOptions: signal ? { signal } : {},
				}),
				]),
			),
			cache: new InMemoryCache({
				addTypename: false
			}),

			defaultOptions: {
				query: {
					//errorPolicy: 'all'
				},
			},
		});

		await client
			.query({
				query: gql(query),
				variables: variables,
				fetchPolicy: 'no-cache',
			})
			.then((res) => {
				returnCall = true;
				returnData = res.data;
			})
			.catch((error) => {
				// Handle AbortError - exit immediately without retry
				if (error.name === 'AbortError' || signal?.aborted) {
					returnCall = true;
					returnError = error;
					returnError.aborted = true;
					return;
				}
				if (refreshToken) {
					attempts = attempts + 1;
					returnError = error;
				
					if (attempts === 5) returnCall = true;
				} else {
					returnCall = true;
					returnError = error;
				}
			});

		if (!returnCall) {
			await clientGraphQLAuthMutation(`
				mutation refreshToken($refreshToken: String!) {
					result: refreshToken(refreshToken: $refreshToken) {
							AccessToken
							ExpiresIn
							IdToken
							RefreshToken
						}
					}
				`,
				{
					refreshToken: refreshTokenValue
				}
			).then(data => {
				if (data && data.result) {
					const { AccessToken, IdToken } = data.result
					token = IdToken;
					localStorage.setItem('IdToken', IdToken);
					localStorage.setItem('AccessToken', AccessToken);
					const eventSuccess = new CustomEvent("refreshToken");
					document.dispatchEvent(eventSuccess);
				}
			}).catch(error => {
				if (error.message === "GraphQL error: Refresh Token has expired" || error.message === "NotAuthorizedException: Invalid Refresh Token") {
					localStorage.clear();
					window.location.replace("/login");
				}
			})
		}
	}

	if (returnCall && returnError && refreshToken) {
		localStorage.clear();
		window.location.replace("/login");
		return
	}

	return new Promise((resolve, reject) => {
		if (!returnError) return resolve(returnData);
		else {
			return reject({
				error: returnError.message,
				innerError: returnError,
				errorData: errorData,
				aborted: returnError.aborted || false,
			});
		}
	});
};

export const clientGraphQLAuthMutation = async (query, variables) => {

	const authLink = new ApolloLink((operation, forward) => {
		// Use the setContext method to set the HTTP headers.
		operation.setContext({
			headers: {
				"x-api-key": endpoints.COGNITO_API_KEY,
				"app-id": "CLOUD-PM",
			}
		});

		// Call the next link in the middleware chain.
		return forward(operation);
	});

	const client = new ApolloClient({
		link: authLink.concat(
			ApolloLink.from([
				new HttpLink({
					uri: endpoints.COGNITO_URL,
				}),
			]),
		),
		cache: new InMemoryCache({
			addTypename: false
		})
	});

	return await client
		.mutate({
			mutation: gql(query),
			variables: variables,
			fetchPolicy: 'no-cache',
		})
		.then(res => {
			return new Promise((resolve, reject) => {
				resolve(res.data)
			});
		})
		.catch(error => {
			return new Promise((resolve, reject) => {
				reject(error)
			});
		})
};
